module.exports = __webpack_public_path__ + "static/media/barcode-qr.e3a789b2.svg";